/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { SLICE } from 'modules/dashboard/constants';
import { signInActions } from 'modules/sign-in/slice';

export const initialState = {
  loading: false,
  emailId: '',
  userInvite: '',
  token: '',
};
/**
 * Here mentioned all the verify call back feature related actions
 */
export const verifyCallbackSlice = createSlice({
  name: SLICE.VERIFY_CALLBACK,
  initialState,
  reducers: {
    verifyToken(state) {
      state.loading = true;
    },
    verifyTokenSucceeded(state, action) {
      state.loading = false;
      state.userInvite = action?.payload?.userInvite;
      state.token = action?.payload?.token;
    },
    verifyTokenFailed(state) {
      state.loading = false;
    },
    setEmailId(state, action) {
      state.emailId = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(signInActions.signIn, (state) => ({
      ...state,
      ...initialState,
    }));
  },
});
//
export const { actions: verifyCallbackActions } = verifyCallbackSlice;
